import { baseUrl } from './baseUrl'

export async function fetchConfig<T>(url: string = import.meta.env.VITE_APP_CONFIG_FILENAME): Promise<T> {
  try {
    const response = await fetch(baseUrl(url))
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error
  }
}
